import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";

function Videoshortcut() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreview1, setImagePreview1] = useState(null);
  const [banner, setBanner] = useState([]);
  const [Heading, setHeading] = useState("");
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedHeading, setSelectedHeading] = useState("");
  const [shortcutHeadings, setShortcutHeadings] = useState([]);

  const getVideoshort = async () => {
    try {
      const response = await privateRequest.get(
        "/VideoShortcut/Videoshortbystatus"
      );
      setBanner(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getShortcutHeadings = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceShortcutHeading/GetShortcuteByStatus`
      );
      // setCombineData(response?.data?.data);
      setShortcutHeadings(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const DeleteVideoShort = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `VideoShortcut/VDeleteShortcute/${_id}`
        );
        getVideoshort();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };
  const AddVideoShort = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("thumbnail", selectedFile);
      formData.append("videoLink", selectedFile1);
      formData.append("heading", Heading);
      formData.append("Status", selectedStatus);
      formData.append("SectionId", selectedHeading?.value);

      let response;
      if (selectedItem._id) {
        // Update existing item
        response = await privateRequest.put(
          `VideoShortcut/VUpdateShortcut/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "VideoShort updated successfully!",
        });
      } else {
        // Add new item
        response = await privateRequest.post(
          "/VideoShortcut/VAddShortcute",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "VideoShort added successfully!",
        });
      }

      console.log("POST Response:", response);
      getVideoshort();
      setShowModal(false);

      setSelectedFile(null);
      setSelectedFile1(null);
      setImagePreview(null);
      setImagePreview1(null);
      setHeading("");
      setSelectedStatus("");
      setSelectedItem({});
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleHeadingChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;

    setSelectedHeading({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });
  };
  const handleFileInputChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile1(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview1(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    getVideoshort();
    getShortcutHeadings();
  }, []);

  return (
    <>
      {banner.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">ShortCut Video</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);

                        setSelectedFile(null);
                        setSelectedFile1(null);
                        setImagePreview(null);
                        setImagePreview1(null);
                        setSelectedGroup(null);
                        setSelectedVideoUrl(null);
                        setHeading("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">thumbnail</th>
                            <th scope="col">Video</th>
                            <th scope="col">Heading</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>

                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banner?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.thumbnail && (
                                  <img
                                    src={`${Image_URL}${item?.thumbnail}`}
                                    alt="Slider Image"
                                    height="100"
                                    width="100"
                                  />
                                )}
                              </td>
                              <td className="align-center">
                                {item?.videoLink && (
                                  <video controls height="100" width="100">
                                    <source
                                      src={`${Image_URL}${item?.videoLink}`}
                                      type="video/mp4"
                                    />
                                  </video>
                                )}
                              </td>
                              <td className="align-center">
                                {item?.SectionId?.Heading}
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status.toString() === "true"
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item?.Status.toString() === "true"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <p className="mb-0">{item.CreatedBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setSelectedItem(item);
                                      setSelectedFile(null);
                                      setHeading(item?.heading);
                                      setSelectedStatus(
                                        item?.Status ? "1" : "0"
                                      );
                                      setImagePreview(
                                        Image_URL + item.thumbnail
                                      );
                                      setShowModal(true);
                                      let headidd = {
                                        label: item?.SectionId?.Heading,
                                        value: item?.SectionId?._id,
                                      };
                                      setSelectedHeading(headidd);
                                      setSelectedFile(item?.thumbnail);
                                      setSelectedFile1(item?.videoLink);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteVideoShort(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                ShortCut Video
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddVideoShort}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Video</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="video/*"
                        onChange={handleFileInputChange1}
                      />
                    </div>
                  </div>
                  <div className="form-group col-lg-6">
                    <label>Heading</label>
                    <Select
                      isClearable
                      options={shortcutHeadings?.map((group) => ({
                        value: group._id,
                        label: group.Heading,
                      }))}
                      onChange={handleHeadingChange}
                      value={selectedHeading}
                      isMulti={false}
                    />
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  {imagePreview && (
                    <div className="col-lg-12">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default Videoshortcut;
